<template>
  <div class="l-radio">
    <template v-if="printMode && disabled">
      <el-tag v-if="showVal" size="mini" :type="value ? 'success' : 'info'">{{ showVal }}</el-tag>
    </template>
    <el-radio-group v-model="value2" :size="size" v-else>
      <template v-for="(item,index) in options" >
          <el-radio v-if="!isButton" :disabled="disabled" :border="border" :key="index" :label="item[valueKey]">{{item[labelKey]}}</el-radio>
          <el-radio-button v-else :key="index" :disabled="disabled"  :label="item[valueKey]">{{item[labelKey]}}</el-radio-button>
      </template>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  name:'l-radio',
  props: {
      value:{
        type:[String,Number],
        default:''
      },
      labelKey:{
          type:String,
          default:'label'
      },
      valueKey:{
          type:String,
          default:'value'
      },
      options:{
          type:Array,
          default:()=>[]
      },
      size: {
        type:String,
        default:'mini'
      },
      border:Boolean,
      isButton:Boolean,
      disabled:Boolean,
      printMode: {
        default: false
      },
  },
  data () {
    return {
    };
  },
  mounted () {
  },
  computed:{
    value2:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('input', val)
        const obj = this.options.find(t=>t[this.valueKey] == val)
        this.$emit('change', obj)
      }
    },
    showVal() {
      if (!this.value && this.value !== 0) return ''
      let obj = this.options.find(t=>t[this.valueKey] == this.value)
      if (obj) return obj[this.labelKey]
      return ''
    }
  },
  methods:{
  }
}
</script>
<style lang="less">
  @import './index.less';
</style>
